(function() {
  if (!document.querySelector('.variant__input--color-swatch')) return;

  const mainImages = document.querySelectorAll('.photoswipe__image');
  let currentSrcsets = [...mainImages].map(img => img.dataset.srcset || img.srcset || '');

  function swapMainImage(srcset) {
    mainImages.forEach(img => {
      img.srcset = srcset;
      img.dataset.srcset = srcset;
    });
  }

  fetch(window.location.pathname + '.js')
    .then(r => r.json())
    .then(product => {
      const colorImageMap = {};
      product.variants.forEach(v => {
        if (v.option1 && v.featured_image && !colorImageMap[v.option1]) {
          colorImageMap[v.option1] = v.featured_image.src;
        }
      });

      // Color swatch change
      document.querySelectorAll('input[name="Color"]').forEach(input => {
        input.addEventListener('change', function() {
          const color = this.value;
          const baseUrl = colorImageMap[color];
          if (!baseUrl) return;

          const base = baseUrl.split('?')[0];
          const ver = baseUrl.split('?')[1];
          const sized = (w) => `${base.replace('.jpg', `_${w}x.jpg`)}?${ver} ${w}w`;
          const newSrcset = [360, 540, 720, 900, 1080].map(sized).join(', ');

          // Update currentSrcsets index 0 with new color
          currentSrcsets[0] = newSrcset;

          swapMainImage(newSrcset);

          // Update active thumbnail
          const colorSlug = color.toUpperCase().replace(/ /g, '-');
          document.querySelectorAll('a.product__thumb').forEach((t, i) => {
            const img = t.querySelector('img');
            const srcset = img?.srcset || img?.dataset.srcset || '';
            const isMatch = srcset.includes(colorSlug);
            t.classList.toggle('is-active', isMatch && i === 0);
          });

          // Update color label
          const colorLabel = document.querySelector('span[data-variant-color-label]');
          if (colorLabel) colorLabel.textContent = color;
        });
      });

      // Thumbnail click
      document.querySelectorAll('a.product__thumb').forEach((thumb, i) => {
        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const srcset = currentSrcsets[i] || currentSrcsets[0];
          swapMainImage(srcset);

          document.querySelectorAll('a.product__thumb').forEach(t => t.classList.remove('is-active'));
          this.classList.add('is-active');
        });
      });
    });
})();